<template>
  <v-row justify="center">
    <v-card-text>
      <v-container padding-top="15px">
        <v-row style="justify-content: center;">
          <v-expand-transition>
            <v-col cols="12" v-if="message" id="element">
              <v-alert color="red" dense elevation="11" type="error">
                <ul>
                  <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                </ul>
              </v-alert>
            </v-col>
          </v-expand-transition>

          <v-container fluid>
            <v-row>
              <v-col cols="12" v-if="ticket.status.id == 15">
                <v-text-field
                  prepend-icon="mdi-google-drive"
                  v-model="drive"
                  label="Link Google Drive"
                  color="#003790"
                  name="drive"
                ></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="po"
                  label="PO# (required)"
                  color="#003790"
                  name="po"
                ></v-text-field>
              </v-col>
              <v-col cols="2"></v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="so"
                  label="SO#"
                  color="#003790"
                  name="so"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="manager"
                  :items="managers"
                  item-text="name"
                  :item-value="'id'"
                  menu-props="auto"
                  label="Assign PM/SC/PE"
                  hide-details
                  color="#003790"
                  prepend-icon="mdi-account"
                  single-line
                ></v-select>
                <v-btn
                  color="#003790"
                  class="addBTN"
                  text
                  small
                  @click="openModal('manager')"
                  >New PM/SC/PE</v-btn
                >
              </v-col>
              <v-col cols="12" class="col-account ajust">
                <div>
                  <v-icon class="v-icon icon icono ajust-icon"
                    >mdi-account-supervisor</v-icon
                  >
                </div>
                <div class="label-multiselect" style="width: 100%;">
                  <label v-if="ticket.status.id !== 15" class="typo__label"
                    >Add tech(s)</label
                  >
                  <label v-else class="typo__label">Add more managers(s)</label>
                  <multiselect
                    v-if="ticket.status.id !== 15"
                    v-model="tech"
                    :options="techs"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Choose tech(s)"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} Techs selected</span
                      ></template
                    >
                  </multiselect>

                  <multiselect
                    v-else
                    v-model="tech"
                    :options="managers"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Choose manager(s)"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} Techs selected</span
                      ></template
                    >
                  </multiselect>
                  <v-btn
                    v-if="ticket.status.id !== 15"
                    color="#003790"
                    class="addBtn-multiselect"
                    text
                    small
                    @click="openModal('tech')"
                    >New tech</v-btn
                  >
                  <v-btn
                    v-else
                    color="#003790"
                    class="addBtn-multiselect"
                    text
                    small
                    @click="openModal('manager')"
                    >New Manager</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="dialog"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fixedates"
                      label="Date start-end"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dates" range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-row>
                <v-col cols="1">
                  <v-icon class="v-icon icon">mdi-format-align-justify</v-icon>
                </v-col>
                <v-col cols="11" height="100">
                  <vue-editor
                    v-model="content"
                    id="editor"
                    name="description"
                  ></vue-editor>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="openModalDelete()">
          Delete
        </v-btn>
        <v-btn color="red" text @click="close()">
          Close
        </v-btn>
        <v-btn color="green" text @click="validate()" :loading="btnloader">
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
    <UserModal ref="usermodaledit" />
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import apis from '@/apis';
import { VueEditor } from 'vue2-editor';
import Multiselect from 'vue-multiselect';
import UserModal from '@/components/UserModal.vue';
export default {
  data: () => ({
    drive: '',
    loading: false,
    btnloader: false,
    dialog2: false,
    files: [],
    message: false,
    errors: [],
    dialog: false,
    name: null,
    po: null,
    so: null,
    address: null,
    manager: null,
    client: null,
    tech: [],
    fixedates: null,
    statusSet: null,
    apikey: process.env.VUE_APP_API_KEY_MAPS,
    dates: [],
    menu2: false,
    body: null,
    content: '<h3>Add description</h3>',
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  }),
  mounted() {
    this.getTicket();
  },
  computed: {
    ...mapState([
      'user',
      'techs',
      'clients',
      'managers',
      'status',
      'token',
      'projectSelected',
      'ticket',
    ]),
  },
  watch: {
    dates() {
      this.fixedates = this.dates.join(' - ');
    },
  },
  methods: {
    ...mapMutations([
      'setModalProyect',
      'deleteService',
      'updateTicket',
      'setTicket',
      'deleteTicket',
    ]),
    openModalDelete() {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: 'You wont be able to revert this!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            apis.deleteTicket(this.ticket.id).then((data) => {
              this.$swal.fire(
                'Deleted!',
                'Your Service has been deleted.',
                'success',
              );
              this.deleteTicket(data.data.id);
              this.dialog2 = false;
              this.loading = false;
              this.close();
              this.$router.push(`/projects`);
            });
          }
        });
      this.loading = true;
    },
    selectedUser(user) {
      switch (user.type) {
        case 'customer':
          this.client = user.id;
          break;
        case 'technician':
          this.tech.push(user);
          break;
        case 'manager':
          this.manager = user.id;
          break;
        default:
          break;
      }
    },
    openModal(option) {
      this.$refs.usermodaledit.option = option;
      this.$refs.usermodaledit.dialog = true;
    },
    onPlaceChanged(value) {
      this.address = value.formatted_address;
    },
    close() {
      this.$emit('closeEdit', true);
    },
    getTicket() {
      this.name = this.projectSelected.name;
      this.po = this.ticket.po_purchase;
      this.drive = this.ticket.drive;
      this.so = this.ticket.so;
      this.address = this.projectSelected.address;
      this.dates[0] = this.ticket.start;
      this.dates[1] = this.ticket.end;
      this.content = this.ticket.description;
      this.statusSet = this.ticket.status.id;
      this.tech = [...this.ticket.users];
      this.fixedates = this.dates.join(' - ');
      this.manager = this.ticket.manager.id;
      // this.client = this.projectSelected.customer.id;
    },
    getValidate() {
      if (!this.name) {
        this.errors.push('The project / service name is required. ');
      }
      if (!this.manager) {
        this.errors.push('The manager is required.');
      }
      if (!this.po) {
        this.errors.push('The po is required.');
      }
      if (!this.address) {
        this.errors.push('The address is required.');
      }
      if (this.dates.length != 2) {
        this.errors.push('Dates are required .');
      }
      if (!this.tech.length > 0) {
        this.errors.push('The tech is required.');
      }
    },
    validate() {
      this.errors = [];
      if (
        !this.name ||
        !this.manager ||
        !this.po ||
        !this.address ||
        this.dates.length != 2 ||
        !this.tech.length > 0
      ) {
        this.message = true;
        this.getValidate();
      } else {
        this.message = false;
        this.editProject();
      }
    },
    editProject() {
      this.btnloader = true;
      let post = {
        name: this.projectSelected.name,
        manager: this.manager,
        po_purchase: this.po,
        so: this.so,
        address: this.projectSelected.address,
        start: this.dates[0],
        end: this.dates[1],
        drive: this.drive,
        description: this.content,
        status_id: this.statusSet,
        techs: this.tech,
      };
      apis.updateTicket(this.ticket.id, post).then(() => {
        this.$swal.fire(
          'Updated!',
          'Your Service has been updated.',
          'success',
        );
        this.btnloader = false;

        this.getTicket();
        this.$emit('closeEdit', true);
      });
    },
  },
  components: {
    VueEditor,
    Multiselect,
    UserModal,
  },
};
</script>

<style>
.ajust-icon {
  margin: 0 !important;
  padding: 0 9px 0px 0px !important;
}
.ajust {
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 90%;
  background: white;
}
.add-proyect {
  bottom: 12% !important;
  right: 4% !important;
  position: fixed;
}
.headline {
  padding-top: 20px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}
.closeBTN {
  position: absolute;
  top: 10px;
  right: 15px;
}
.addBTN {
  margin-left: 32px;
}
.v-text-field {
  padding-top: 10px;
  margin-top: 0px;
}
.icon {
  margin-left: 14px;
  margin-top: 2px !important;
}
</style>
